import "./AbsenceOverview.css";
import {
    collectAbsenceDaysForEmployee,
    formatHoursMinutes,
    getDaysOfMonth,
    getTypeColor,
    toDateKey
} from "./absenceOverviewUtils";

const weekDayShort = ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"];
const EMPLOYEES_PER_PRINT_PAGE = 9;

function MatrixTable(props) {
    const { employees, days, absenceDaysByEmployee } = props;

    return (
        <table className="absences-matrix">
            <thead>
                <tr>
                    <th className="absences-matrix-day-column">Tag</th>
                    {employees.map(employee => (
                        <th key={employee.employeeId} className="absences-matrix-employee-column">
                            {employee.firstName}
                            <br />
                            {employee.lastName}
                        </th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {days.map(day => {
                    const dateKey = toDateKey(day);
                    const isWeekend = day.getDay() === 0 || day.getDay() === 6;

                    return (
                        <tr key={dateKey} className={isWeekend ? "absences-matrix-weekend" : ""}>
                            <th className="absences-matrix-day-column">
                                {weekDayShort[day.getDay()]} {day.toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit" })}
                            </th>
                            {employees.map((employee, employeeIndex) => {
                                const absenceDay = absenceDaysByEmployee[employeeIndex].get(dateKey);

                                return (
                                    <td key={employee.employeeId}>
                                        {absenceDay &&
                                            <span
                                                className="absences-matrix-cell"
                                                style={{ backgroundColor: getTypeColor(absenceDay.type) }}
                                                title={absenceDay.type + " (" + (absenceDay.paid ? "bezahlt" : "unbezahlt") + "), " + formatHoursMinutes(absenceDay.minutes) + " Std"}
                                            >
                                                {absenceDay.type}
                                            </span>
                                        }
                                    </td>
                                );
                            })}
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );
}

function AbsenceMonthMatrix(props) {
    const { employees, selectedMonth, selectedTypes, periodLabel, filterSummary } = props;

    const year = selectedMonth.getFullYear();
    const monthIndex = selectedMonth.getMonth();
    const days = getDaysOfMonth(year, monthIndex);

    // Pro Mitarbeiter eine Map Datum -> Abwesenheitstag, damit die Tabellen in
    // einem Durchlauf aufgebaut werden können.
    const absenceDaysByEmployee = employees.map(employee => {
        const daysByDate = new Map();
        collectAbsenceDaysForEmployee(employee, year, monthIndex, selectedTypes).forEach(absenceDay => {
            daysByDate.set(toDateKey(absenceDay.date), absenceDay);
        });
        return daysByDate;
    });

    if (employees.length === 0) {
        return <p>Keine Mitarbeiter für die aktuelle Auswahl.</p>;
    }

    // Für den Druck wird die Matrix in Blöcke je Seite aufgeteilt, damit bei
    // vielen Mitarbeitern keine Spalten abgeschnitten werden.
    const printChunks = [];
    for (let startIndex = 0; startIndex < employees.length; startIndex += EMPLOYEES_PER_PRINT_PAGE) {
        printChunks.push({
            employees: employees.slice(startIndex, startIndex + EMPLOYEES_PER_PRINT_PAGE),
            absenceDaysByEmployee: absenceDaysByEmployee.slice(startIndex, startIndex + EMPLOYEES_PER_PRINT_PAGE),
            startNumber: startIndex + 1
        });
    }

    return (
        <>
            <div className="absences-matrix-screen">
                <MatrixTable
                    employees={employees}
                    days={days}
                    absenceDaysByEmployee={absenceDaysByEmployee}
                />
            </div>
            <div className="absences-matrix-print">
                {printChunks.map((chunk, index) => (
                    <div className="absences-print-page" key={chunk.startNumber}>
                        <div className="absences-print-chunk-header">
                            <h3>Abwesenheiten – {periodLabel}</h3>
                            <p>{filterSummary}</p>
                            <p>
                                Mitarbeiter {chunk.startNumber}–{chunk.startNumber + chunk.employees.length - 1} von {employees.length}
                            </p>
                        </div>
                        <MatrixTable
                            employees={chunk.employees}
                            days={days}
                            absenceDaysByEmployee={chunk.absenceDaysByEmployee}
                        />
                    </div>
                ))}
            </div>
        </>
    );
}

export default AbsenceMonthMatrix;
